import React, { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import queryString from 'query-string';

import {
	setAnalyticsSent,
	setCurrentInteractiveElement,
	setCurrentSceneWidgets,
	setPlayerCurrentPosition,
	setShowChatWindow,
	setShowShoppingCart,
} from '../../../actions/playerActions';
import { setCartArray, setCurrentPrebasketProduct, setPrebasketUpdated } from '../../../actions/shoppingActions';
import {
	setChangeSceneType,
	setSceneConfig,
	updateSceneHistory,
	setShouldChangeCurrentMedia,
	setTransitionLayer,
	setTransitionOut,
} from '../../../actions/configurationActions';
import { getSecondsFromTimelineTime, getTimelineTimeFromTimeInput } from '../../../util/util';
import { PLAYER_TRANSITIONS_OUT } from '../../../util/constants';

import SVGWrapper from './SVGWrapper';
import ScalableElement from './ScalableElement';
import ProductElement from './ProductElement';
import WidgetElement from './WidgetElement';
import { INTERACT_ELEMENT_ACTIONS, WIDGET_ACTIONS } from './util';

import './InteractOverlay.scss';

class InteractOverlay extends PureComponent {
	constructor() {
		super();
		this.state = {
			analyticsSent: false,
			currentProduct: null,
		};

		this.interactOverlayContainerRef = createRef(null);
		this.currentPlayerId = `player-${this.props?.playlistId || this.props?.mediaId}`;
	}

	componentDidMount() {
		this.currentPlayerId = `player-${this.props?.playlistId || this.props?.mediaId}`;
		this.getLiveMediaCurrentProduct();
	}

	componentDidUpdate(preProps, _prevState) {
		if (preProps.currentPosition !== this.props.currentPosition && this.props.currentPosition !== '' && this.props.currentPosition > 0) {
			if (this.props.isMediaLive) {
				this.getLiveMediaCurrentProduct();
			} else {
				const elements = this.props.mediaType === 'scenario' ? this.props.currentSceneWidgets : this.props.currentInteractiveElement;

				let found =
					this.props.mediaType === 'scenario'
						? (elements ?? []).filter((el) => this.props.currentPosition >= el.start && this.props.currentPosition < el.end)
						: (elements ?? []).find((el) => this.props.currentPosition >= el.start && this.props.currentPosition < el.end);

				if (found) {
					if (this.props.mediaType !== 'scenario' || !this.isScenarioInteractElementsEqual(found, _prevState.currentProduct)) {
						this.setState({ currentProduct: found });
					}
				} else if (_prevState.currentProduct && _prevState.currentProduct.length !== 0) {
					this.setState({ currentProduct: [] });
				}
			}
		}

		if (preProps.showBackgroundElements !== this.props.showBackgroundElements) {
			let interactiveElements = document.querySelector('.elementWrapper') === null ? [] : document.querySelector('.elementWrapper').children;
			let shoppingBasketElement = document.querySelector('.gobrain-shopping-basket');
			let shoppingPreBasketElement = document.querySelector('.gobrain-shopping-pre-basket');

			for (var i = 0; i < interactiveElements.length; i++) {
				let element = interactiveElements[i];
				if (this.isElementOverlapping(element, shoppingBasketElement) || this.isElementOverlapping(element, shoppingPreBasketElement)) {
					element.classList.add('hideElement');
				} else {
					element.classList.remove('hideElement');
				}
			}
		}

		const _thisElements = this.props.mediaType === 'scenario' ? this.props.currentSceneWidgets : this.props.currentInteractiveElement;
		const _prevElements = this.props.mediaType === 'scenario' ? preProps.currentSceneWidgets : preProps.currentInteractiveElement;
		if (_thisElements !== _prevElements && this.props.analyticsSent !== false) {
			if (!_thisElements || _thisElements.length === 0) {
				this.props.setAnalyticsSent(false);
			}
		}

		if (this.props.mediaId !== preProps.mediaId || this.props.playlistId !== preProps.playlistId) {
			this.currentPlayerId = `player-${this.props?.playlistId || this.props?.mediaId}`;
		}
	}

	isScenarioInteractElementsEqual = (interact1, interact2) => {
		if (!interact1 && !interact2) {
			return true;
		}

		let sortedInteract1 = Array.from(interact1 ?? []).sort((a, b) => (a.id > b.id ? 1 : -1));
		let sortedInteract2 = Array.from(interact2 ?? []).sort((a, b) => (a.id > b.id ? 1 : -1));

		sortedInteract1 = sortedInteract1.map((i) => i.id).filter(Boolean);
		sortedInteract2 = sortedInteract2.map((i) => i.id).filter(Boolean);

		return sortedInteract1.join(',') === sortedInteract2.join(',');
	};

	getLiveMediaCurrentProduct = () => {
		if (!this.props.isMediaLive) {
			return;
		}
		const elements = this.props.mediaType === 'scenario' ? this.props.currentSceneWidgets : this.props.currentInteractiveElement;
		const currentInteractiveElementArray = !elements ? [] : elements.map ? elements : [elements];
		const newProduct =
			this.props.mediaType === 'scenario'
				? currentInteractiveElementArray.filter((item) => !item.end && item.start)
				: currentInteractiveElementArray.find((item) => !item.end && item.start);
		this.setState({ currentProduct: newProduct });
	};

	handleClickOnProduct = (event, targetElement) => {
		var playerElement = document.getElementById(this.currentPlayerId);
		event.preventDefault();

		var message;
		var priceCurrency = targetElement.price.value.slice(-3);

		if (targetElement.variantCombinations && targetElement.variantCombinations.value && targetElement.variantCombinations.value.length > 0) {
			var variationComboArray = targetElement.variantCombinations.value.map((elem) => ({
				comboName: elem.comboName,
				comboId: elem.comboId,
				comboImg: elem.comboImg === '' ? targetElement.imageUrl.value : elem.comboImg,
				comboPrice: elem.comboPrice + ' ' + priceCurrency,
			}));
			message =
				targetElement.prodName.value +
				'=)' +
				targetElement.prodId.value +
				'=)' +
				targetElement.prodPage.value +
				'=)' +
				targetElement.price.value +
				'=)' +
				targetElement.prodDescription.value +
				(targetElement.hideVolumeCounter === undefined ? '' : '(=' + targetElement.hideVolumeCounter.value) +
				'=)' +
				targetElement.imageUrl.value +
				'=)' +
				(targetElement.variantName1.value === undefined ? '' : targetElement.variantName1.value) +
				'=)' +
				(targetElement.variantName2.value === undefined ? '' : targetElement.variantName2.value) +
				'=)' +
				(targetElement.variantValues1.value === undefined ? '' : targetElement.variantValues1.value.join()) +
				'=)' +
				(targetElement.variantValues2.value === undefined ? '' : targetElement.variantValues2.value.join()) +
				'=)' +
				JSON.stringify(variationComboArray);
			playerElement.querySelectorAll("[data-internal-gobrain-box-configuration-modulename='Controls']")[0].parentNode.style.zIndex = 250;
		} else {
			message =
				targetElement.prodName.value +
				'=)' +
				targetElement.prodId.value +
				'=)' +
				targetElement.prodPage.value +
				'=)' +
				targetElement.price.value +
				'=)' +
				targetElement.prodDescription.value +
				(targetElement.hideVolumeCounter === undefined ? '' : '(=' + targetElement.hideVolumeCounter.value) +
				'=)' +
				targetElement.imageUrl.value;
		}

		window.parent.postMessage(
			{
				origin: 'Qbrick.Interact.Widget.Element',
				identifier: 'qbrick-player-analytics-message',
				command: {
					type: 'AnalyticsEvent',
					action: 'click',
					data: 'clickedProduct',
					mediaName: this.props.mediaName,
					mediaId: this.props.mediaId,
					accountId: this.props.accountId,
					duration: this.props.duration,
					isMediaLive: this.props.isMediaLive,
					currentPosition: this.props.isMediaLive ? Date.now() : this.props.currentPosition,
					productId: targetElement.prodId.value,
					message: message,
				},
			},
			'*'
		);

		var obj = {
			productId: targetElement.prodId.value,
			productPage: targetElement.prodPage.value,
			name: targetElement.prodName.value,
			price: targetElement.price.value,
			quantity:
				targetElement.hideVolumeCounter === undefined ||
				(targetElement.hideVolumeCounter !== undefined && targetElement.hideVolumeCounter.value === false)
					? '1'
					: '0',
			description:
				targetElement.prodDescription.value +
				(targetElement.hideVolumeCounter === undefined ? '' : '(=' + targetElement.hideVolumeCounter.value),
			image: targetElement.imageUrl.value,
		};

		if (targetElement.variantCombinations && targetElement.variantCombinations.value && targetElement.variantCombinations.value.length > 0) {
			if (this.props.settings.engagementFeatures.showShoppingCart) {
				this.props.setShowShoppingCart(true);
				this.props.setCurrentPrebasketProduct(targetElement);
				this.props.setPrebasketUpdated(true);
				this.props.setShowChatWindow(false);
			}
		} else {
			if (!this.props.cartArray.some((el) => el.productId === obj.productId)) {
				var tempArray = this.props.cartArray;
				tempArray.push(obj);
				this.props.setCartArray(tempArray);
				this.props.setShowChatWindow(false);
			}
		}
	};

	isElementOverlapping = (el1, el2) => {
		const domRect1 = el1.getBoundingClientRect();
		const domRect2 = el2.getBoundingClientRect();

		return !(
			domRect1.top > domRect2.bottom ||
			domRect1.right < domRect2.left ||
			domRect1.bottom < domRect2.top ||
			domRect1.left > domRect2.right
		);
	};

	handleOnInteractiveElementEnter = () => {
		const { currentProduct } = this.state;
		if (!currentProduct || currentProduct.length === 0) {
			return;
		}
		if (currentProduct.custom?.interactiveWidget?.settings?.general?.onEntry?.value === 'pause') {
			window.GoBrain.widgets(this.currentPlayerId).pause();
		}
	};

	handleClickOnInteractiveElement = (event, targetElement) => {
		let elementActions = targetElement.action.value;
		event.stopPropagation();
		event.preventDefault();
		this.props.handlePlayerHover?.();

		window.parent.postMessage(
			{
				origin: 'Qbrick.Interact.Widget.Element',
				identifier: 'qbrick-player-analytics-message',
				command: {
					type: 'AnalyticsEvent',
					action: 'click',
					data: 'clickedInteractiveElement',
					mediaName: this.props.mediaName,
					mediaId: this.props.mediaId,
					accountId: this.props.accountId,
					duration: this.props.duration,
					isMediaLive: this.props.isMediaLive,
					currentPosition: this.props.isMediaLive ? Date.now() : this.props.currentPosition,
				},
			},
			'*'
		);
		const queryParams = queryString.parse(window.location.search);
		const urlOpenTarget = queryParams.uniqueFrame === 'true' ? '_self' : '_parent';
		const uniqueFrameParam = queryParams.uniqueFrame === 'true' ? '&uniqueFrame=true' : '';

		for (const key in elementActions) {
			const elementValue = elementActions[key]?.value ?? '';
			switch (key) {
				case INTERACT_ELEMENT_ACTIONS.openUrl:
					window.open(
						`${elementValue}${elementActions[key].target === '_blank' ? '' : elementValue.includes('qplayer') ? uniqueFrameParam : ''}`,
						elementActions[key].target === '_blank' ? elementActions[key].target : urlOpenTarget
					);
					break;
				case INTERACT_ELEMENT_ACTIONS.jumpToTime:
					window.GoBrain.widgets(this.currentPlayerId).position(elementActions[key].value);
					window.GoBrain.widgets(this.currentPlayerId).play();
					break;
				case INTERACT_ELEMENT_ACTIONS.loadVideo: {
					this.props.setCurrentInteractiveElement([]);
					this.props.setShouldChangeCurrentMedia(true);
					window.GoBrain.widgets(this.currentPlayerId).data(elementActions[key].value, {}, true);
					break;
				}
				case INTERACT_ELEMENT_ACTIONS.videoToPlaylist:
					window.GoBrain.widgets(this.currentPlayerId).data(elementActions[key].value, {}, false);
					break;
				case INTERACT_ELEMENT_ACTIONS.playPause:
					if (elementActions[key].value === INTERACT_ELEMENT_ACTIONS.play) {
						window.GoBrain.widgets(this.currentPlayerId).play();
					} else if (elementActions[key].value === INTERACT_ELEMENT_ACTIONS.pause) {
						window.GoBrain.widgets(this.currentPlayerId).pause();
					}
					break;
				case INTERACT_ELEMENT_ACTIONS.customEvent:
					break;
				case INTERACT_ELEMENT_ACTIONS.fadeOut:
					if (elementActions[key].value === true) {
						event.currentTarget.classList.add(INTERACT_ELEMENT_ACTIONS.fadeOut);
					}
					break;
			}
		}
	};

	handleClickOnWidget = (e, element) => {
		e.stopPropagation();
		e.preventDefault();

		this.props.handlePlayerHover?.();

		const {
			data: { events },
		} = element;
		const {
			setChangeSceneType,
			setSceneConfig,
			sceneConfig,
			updateSceneHistory,
			setTransitionLayer,
			scenario,
			setTransitionOut,
		} = this.props;
		const event = (events ?? []).find((event) => event.type === WIDGET_ACTIONS.clickActions.type);

		if (event) {
			const { actions } = event;
			const action = actions && actions.length > 0 ? actions[0] : undefined;

			if (action) {
				const { type, metadata } = action;

				setChangeSceneType(type);
				const queryParams = queryString.parse(window.location.search);
				const urlOpenTarget = queryParams.uniqueFrame === 'true' ? '_self' : '_parent';
				const uniqueFrameParam = metadata.openNewTab ? '' : queryParams.uniqueFrame === 'true' ? '&uniqueFrame=true' : '';

				switch (type) {
					// continue to implement other funcs
					case WIDGET_ACTIONS.clickActions.goToScene: {
						if (sceneConfig?.currentScene) {
							updateSceneHistory(sceneConfig?.currentScene);
						}

						const currentSceneId = sceneConfig?.currentScene;
						const currentSceneData = currentSceneId && (scenario?.scenes ?? []).find((s) => s.id === currentSceneId);

						let transitionOut = PLAYER_TRANSITIONS_OUT.fadeOut;
						if (currentSceneData?.metadata?.transition) {
							transitionOut = currentSceneData.metadata.transition.out ?? PLAYER_TRANSITIONS_OUT.fadeOut;
						}

						//make sure that transition layer should be trigger 1st. Then others scene change stuffs
						setTransitionLayer(true);
						setTransitionOut(transitionOut);
						setSceneConfig?.({ currentScene: metadata.sceneId });
						this.setState({ currentProduct: [] });
						setTimeout(() => {
							setCurrentSceneWidgets(null);
							setPlayerCurrentPosition(0);
						}, 100);
						break;
					}
					case WIDGET_ACTIONS.clickActions.goToUrl: {
						let openUrl = `${metadata.url}${metadata.url?.includes('qplayer') ? uniqueFrameParam : ''}`;
						const isValid = openUrl.match('^(http|https)://');
						if (isValid?.[0] === 'http://' || isValid?.[0] === 'https://') {
							window.open(openUrl, metadata.openNewTab ? '_blank' : urlOpenTarget);
						} else {
							window.open(`https://${openUrl}`, metadata.openNewTab ? '_blank' : urlOpenTarget);
						}
						break;
					}
					case WIDGET_ACTIONS.clickActions.jumpToTime: {
						const { time } = metadata;
						window.GoBrain.widgets(this.currentPlayerId)?.position?.(getSecondsFromTimelineTime(getTimelineTimeFromTimeInput(time)));
						window.GoBrain.widgets(this.currentPlayerId)?.play?.();
					}
				}
			}
		}
	};

	handleOnWidgetEntry = (element) => {
		const {
			data: { events },
		} = element;
		const entryEvent = (events ?? []).find((event) => event.type === WIDGET_ACTIONS.entryActions.type);
		const entryActions = (entryEvent?.actions ?? [])?.filter((action) => action.type);

		if (entryActions && entryActions.length) {
			for (const actionIndex in entryActions) {
				switch (entryActions[actionIndex]?.type) {
					case WIDGET_ACTIONS.entryActions.pause:
						window.GoBrain.widgets(this.currentPlayerId)?.pause?.();
						break;
					case WIDGET_ACTIONS.entryActions.jumpToTime: {
						const { time } = entryActions[actionIndex].metadata;
						window.GoBrain.widgets(this.currentPlayerId)?.position?.(getSecondsFromTimelineTime(getTimelineTimeFromTimeInput(time)));
						window.GoBrain.widgets(this.currentPlayerId)?.play?.();
						break;
					}
				}
			}
		}
	};

	handleOnWidgetExit = (element) => {
		const {
			data: { events },
		} = element;
		const exitEvent = (events ?? []).find((event) => event.type === WIDGET_ACTIONS.exitActions.type);
		const exitActions = (exitEvent?.actions ?? [])?.filter((action) => action.type);

		if (exitActions && exitActions.length) {
			for (const actionIndex in exitActions) {
				switch (exitActions[actionIndex]?.type) {
					case WIDGET_ACTIONS.exitActions.pause:
						window.GoBrain.widgets(this.currentPlayerId)?.pause?.();
						break;
					case WIDGET_ACTIONS.exitActions.jumpToTime: {
						const { time } = exitActions[actionIndex].metadata;
						window.GoBrain.widgets(this.currentPlayerId)?.position?.(getSecondsFromTimelineTime(getTimelineTimeFromTimeInput(time)));
						window.GoBrain.widgets(this.currentPlayerId)?.play?.();
						break;
					}
				}
			}
		}
	};

	shouldShowVerticalViewBox = () => {
		const { queryParams, mediaId, mediasData } = this.props;
		if (queryParams?.fromQplayerWidget === "true") {
			return true;
		}
		const currentMedia = mediasData.find(({ id, originalId }) => id === mediaId || originalId === mediaId);
		return Math.floor(currentMedia?.videoWidth/ currentMedia?.videoHeight * 100)/100 === Math.floor(9 / 16 * 100)/100;
	}

	renderProducts = () => {
		const productElement = this.state.currentProduct;
		var insertedElements = [];
		if (productElement && productElement.custom && productElement.custom.interactiveWidget && productElement.custom.interactiveWidget.settings) {
			for (const el in productElement.custom.interactiveWidget.settings) {
				if (
					Object.prototype.hasOwnProperty.call(productElement.custom.interactiveWidget.settings[el], 'type') &&
					productElement.custom.interactiveWidget.settings[el].type === 'button'
				) {
					insertedElements.push(productElement.custom.interactiveWidget.settings[el]);
				}
			}
		}

		if (
			productElement &&
			productElement.custom &&
			productElement.custom.interactiveWidget &&
			productElement.custom.interactiveWidget.settings &&
			productElement.custom.interactiveWidget.settings.general &&
			productElement.custom.interactiveWidget.settings.general.jumpToTime &&
			productElement.custom.interactiveWidget.settings.general.jumpToTime.value
		) {
			window.GoBrain.widgets(this.currentPlayerId).position(productElement.custom.interactiveWidget.settings.general.jumpToTime.value);
			return <div onTouchEnd={this.props.handlePlayerHover} onTouchMove={this.props.onTouchMove}></div>;
		}

		if (!this.props.analyticsSent) {
			var prodIdArray = [];
			var typeOfMessage = '';

			for (var n = 0; n < insertedElements.length; n++) {
				if (insertedElements[n].imageUrl !== undefined && insertedElements[n].prodId !== undefined) {
					prodIdArray.push(insertedElements[n].prodId.value);
					typeOfMessage = 'product';
				} else if (insertedElements[n].imageUrl !== undefined && insertedElements[n].prodId === undefined) {
					typeOfMessage = 'image';
				} else {
					typeOfMessage = 'button';
				}
			}
			if (typeOfMessage === 'product') {
				window.parent.postMessage(
					{
						origin: 'Qbrick.Interact.Widget.Element',
						identifier: 'qbrick-player-analytics-message',
						command: {
							type: 'AnalyticsEvent',
							action: 'display',
							data: 'showProductElement',
							mediaName: this.props.mediaName,
							mediaId: this.props.mediaId,
							accountId: this.props.accountId,
							duration: this.props.duration,
							isMediaLive: this.props.isMediaLive,
							currentPosition: this.props.isMediaLive ? Date.now() : this.props.currentPosition,
							productIdArray: prodIdArray,
						},
					},
					'*'
				);
			} else if (typeOfMessage === 'image') {
				window.parent.postMessage(
					{
						origin: 'Qbrick.Interact.Widget.Element',
						identifier: 'qbrick-player-analytics-message',
						command: {
							type: 'AnalyticsEvent',
							action: 'display',
							data: 'showImageElement',
							mediaName: this.props.mediaName,
							mediaId: this.props.mediaId,
							accountId: this.props.accountId,
							duration: this.props.duration,
							isMediaLive: this.props.isMediaLive,
							currentPosition: this.props.isMediaLive ? Date.now() : this.props.currentPosition,
						},
					},
					'*'
				);
			} else if (typeOfMessage === 'button') {
				window.parent.postMessage(
					{
						origin: 'Qbrick.Interact.Widget.Element',
						identifier: 'qbrick-player-analytics-message',
						command: {
							type: 'AnalyticsEvent',
							action: 'display',
							data: 'showButtonElement',
							mediaName: this.props.mediaName,
							mediaId: this.props.mediaId,
							accountId: this.props.accountId,
							duration: this.props.duration,
							isMediaLive: this.props.isMediaLive,
							currentPosition: this.props.isMediaLive ? Date.now() : this.props.currentPosition,
						},
					},
					'*'
				);
			}
		}

		return (
			<SVGWrapper
				className={this.props.isMaintainProportions === false ? "interactOverlayContainer--adjust-proportions" : ""}
				isMobile={this.props.isMobile}
				onMouseLeave={this.props.onMouseLeave}
				onMouseMove={this.props.onMouseMove}
				onTouchEnd={this.props.handlePlayerHover}
				onTouchMove={this.props.onTouchMove}
				showVerticalViewBox={this.shouldShowVerticalViewBox()}
				noMouseEvent={true}
				settings={this.props.settings}
			>
				{insertedElements.map((el, i) => {
					if (el.imageUrl !== undefined && el.prodId !== undefined) {
						return (
							<ProductElement
								isMobile={this.props.isMobile}
								key={i}
								element={el}
								index={i}
								image
								onClick={(e) => this.handleClickOnProduct(e, el)}
								onEnter={this.handleOnInteractiveElementEnter}
							/>
						);
					} else if (el.imageUrl !== undefined && el.prodId === undefined) {
						return (
							<ProductElement
								isMobile={this.props.isMobile}
								key={i}
								element={el}
								index={i}
								onClick={(e) => this.handleClickOnInteractiveElement(e, el)}
								onEnter={this.handleOnInteractiveElementEnter}
							/>
						);
					} else {
						return (
							<ScalableElement
								isMobile={this.props.isMobile}
								key={i}
								element={el}
								index={i}
								onClick={(e) => this.handleClickOnInteractiveElement(e, el)}
								onEnter={this.handleOnInteractiveElementEnter}
							/>
						);
					}
				})}
			</SVGWrapper>
		);
	};

	renderSceneWidgets = () => {
		const insertedElements = (this.state.currentProduct ?? [])
			.sort((a, b) => (a.id > b.id ? 1 : -1)) // Sort by ID to keep the order of the elements
			.sort((elementA, elementB) => {
				// Sort by zIndex
				const {
					data: {
						style: { zIndex: zIndexA = 0 },
					},
				} = elementA;
				const {
					data: {
						style: { zIndex: zIndexB = 0 },
					},
				} = elementB;

				return zIndexA > zIndexB ? 1 : -1;
			});

		return (
			<SVGWrapper
				className={this.props.isMaintainProportions === false ? "interactOverlayContainer--adjust-proportions" : ""}
				isMobile={this.props.isMobile}
				onMouseLeave={this.props.onMouseLeave}
				onMouseMove={this.props.onMouseMove}
				onTouchEnd={this.props.handlePlayerHover}
				onTouchMove={this.props.onTouchMove}
				showVerticalViewBox={this.shouldShowVerticalViewBox()}
				noMouseEvent={false}
				settings={this.props.settings}
			>
				{insertedElements.map((el) => {
					const { data: { style, events } = {}, id } = el;

					if (!style) {
						return null;
					}
					const currentScene = this.props.scenario.scenes?.find(({ id }) => id === this.props.sceneConfig.currentScene);
					return (
						<WidgetElement
							isMobile={this.props.isMobile}
							id={id}
							key={id}
							style={style}
							data={el.data}
							clickable={events && events.length > 0}
							onClick={(e) => this.handleClickOnWidget(e, el)}
							onEnter={() => this.handleOnWidgetEntry(el)}
							onExit={() => this.handleOnWidgetExit(el)}
							scenarioId={`${this.props.scenario?.metadata?.title}#${this.props.scenario.id}`}
							sceneId={`${currentScene?.name}#${this.props.sceneConfig.currentScene}`}
						/>
					);
				})}
			</SVGWrapper>
		);
	};

	render() {
		const { mediaId, mediasData } = this.props;
		const currentMedia = mediasData.find((media) => media?.id === mediaId);

		if (currentMedia?.custom?.['event-start']) {
			return null;
		}

		if (this.props.mediaType === 'scenario') {
			return this.renderSceneWidgets();
		}
		return this.renderProducts();
	}
}

const mapStateToProps = ({ playerReducer, configurationReducer, shoppingReducer }) => ({
	currentPosition: playerReducer.currentPosition,
	showBackgroundElements: playerReducer.showBackgroundElements,
	currentInteractiveElement: playerReducer.currentInteractiveElement,
	mediaName: configurationReducer.mediaName,
	mediaId: configurationReducer.currentMediaId,
	playlistId: configurationReducer.playlistId,
	accountId: configurationReducer.accountId,
	duration: playerReducer.duration,
	isMediaLive: configurationReducer.isMediaLive,
	analyticsSent: playerReducer.analyticsSent,
	cartArray: shoppingReducer.cartArray,
	mediaType: configurationReducer.mediaType,
	currentSceneWidgets: playerReducer.currentSceneWidgets,
	sceneConfig: configurationReducer.sceneConfig,
	isMaintainProportions: configurationReducer.isMaintainProportions,
	scenario: configurationReducer.scenario,
	mediasData: configurationReducer.mediasData,
});

const mapDispatchToProps = (dispatch) => ({
	setAnalyticsSent: (value) => dispatch(setAnalyticsSent(value)),
	setCartArray: (value) => dispatch(setCartArray(value)),
	setShowShoppingCart: (value) => dispatch(setShowShoppingCart(value)),
	setCurrentPrebasketProduct: (value) => dispatch(setCurrentPrebasketProduct(value)),
	setPrebasketUpdated: (value) => dispatch(setPrebasketUpdated(value)),
	setCurrentInteractiveElement: (elements) => dispatch(setCurrentInteractiveElement(elements)),
	setShowChatWindow: (show) => dispatch(setShowChatWindow(show)),
	setSceneConfig: (value) => dispatch(setSceneConfig(value)),
	setCurrentSceneWidgets: (widgets) => dispatch(setCurrentSceneWidgets(widgets)),
	setShouldChangeCurrentMedia: (value) => dispatch(setShouldChangeCurrentMedia(value)),
	setChangeSceneType: (value) => dispatch(setChangeSceneType(value)),
	updateSceneHistory: (value) => dispatch(updateSceneHistory(value)),
	setTransitionLayer: (isActive) => dispatch(setTransitionLayer(isActive)),
	setTransitionOut: (transitionName) => dispatch(setTransitionOut(transitionName)),
	setPlayerCurrentPosition: (pos) => dispatch(setPlayerCurrentPosition(pos)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(InteractOverlay);
